import React, { createContext, useContext, useState, useEffect } from 'react';
import { isFullAdminFromStorage } from '../utils/staffAccess';

const EditModeContext = createContext();

export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context) {
    throw new Error('useEditMode must be used within an EditModeProvider');
  }
  return context;
};

export const EditModeProvider = ({ children }) => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const fullAdmin = isFullAdminFromStorage();
    setIsAdmin(fullAdmin);
    if (!fullAdmin) {
      setIsEditMode(false);
    }
  }, []);

  const toggleEditMode = () => {
    if (isAdmin) {
      setIsEditMode(prev => !prev);
    }
  };

  const value = {
    isEditMode,
    isAdmin,
    toggleEditMode,
    setIsEditMode
  };

  return (
    <EditModeContext.Provider value={value}>
      {children}
    </EditModeContext.Provider>
  );
}; 